import { styled } from 'styled-components';

export const Title = styled.h3`
  color: var(--color-text-light);
  font-size: var(--font-baseline);
`;
